/**
 * Maximum size for profile photo.
 * 1 MB = 1048576 B
 */
const MAX_FILE_SIZE = 1048576;

const HELP_TO_PASSWORD = 'Hasło powinno składać się z co najmniej 8 i co najwyżej 16 znaków, zawierać co najmniej jedną małą literę, jedną wielką literę oraz jedną cyfrę.';

const linkToCompany = 'http://www.ambsoft.pl';
const nameCompany = 'ambsoftware';
const alert =
    {
        alternativeOptions:
            {timeout: 'none', html: true, position: 'top'}
    };
const events = {
    checkTypes: [1, 3, 5, 6, 8]
};

const CALENDAR = {
    timeFormat: 'pl',
    daysOfWeek: [0, 6],
    numberOfMonths: 2
};

export {
    MAX_FILE_SIZE,
    HELP_TO_PASSWORD,
    linkToCompany,
    nameCompany,
    alert,
    events,
    CALENDAR,
};



// WEBPACK FOOTER //
// ./src/constantValues/OTHER.js